import React from 'react'

import { Grid, Chip, IconButton } from '@material-ui/core'
import { Autorenew } from '@material-ui/icons'

import useStyles from './return.styles'

import { ORDER_STATUSES, RETURN_OPTIONS } from 'constants/returnsConst'

const translateDate = (date) => {
  return new Date(date).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}
const ChipsReturn = ({
  request,
  setRequest,
  setDate,
  sellers,
  filterList,
  getReturnsByFilter,
  setFilterList,
}) => {
  const classes = useStyles()
  const deleteDate = () => {
    const requestWODate = { ...request }
    delete requestWODate.dateFrom
    delete requestWODate.dateTo
    setDate({
      initialDate: null,
      finalDate: new Date(),
    })
    setRequest({
      ...requestWODate,
      page: 1,
    })
  }
  const deleteStatus = (type) => {
    const newFilterList = request.filters.filter((requestList) => requestList.type !== type)
    setFilterList(filterList.filter((filter) => filter.type !== type))
    setRequest({
      ...request,
      page: 1,
      filters: newFilterList,
    })
  }
  const deleteSeller = () => {
    const requestWODate = { ...request }
    delete requestWODate.sellerId
    setRequest({
      ...requestWODate,
      page: 1,
    })
  }
  const getFilterLabel = (name, type, value) => {
    let labelValue

    if (type === 2) {
      labelValue = ORDER_STATUSES.find((s) => s.id === value)?.name ?? value
    } else if (type === 3) {
      labelValue = RETURN_OPTIONS.find((o) => o.id === value)?.name ?? value
    } else {
      labelValue = value
    }

    return `${String(name).toLocaleUpperCase()}: ${String(labelValue).toLocaleUpperCase()}`
  }
  return (
    <Grid container direction="row" alignItems="center" spacing={1}>
      {request.dateTo && request.dateFrom && (
        <Grid item>
          <li className={classes.liReset}>
            <Chip
              label={`FECHA DE SOLICITUD: ${translateDate(request.dateFrom)}
                                  - ${translateDate(request.dateTo)}`}
              className={classes.chip}
              onDelete={() => deleteDate()}
            />
          </li>
        </Grid>
      )}
      {request.sellerId && (
        <Grid item>
          <li className={classes.liReset}>
            <Chip
              className={classes.chip}
              label={`TIENDA: ${sellers.find((seller) => seller.id === request.sellerId).name}`}
              onDelete={() => deleteSeller()}
            />
          </li>
        </Grid>
      )}
      {filterList.map(({ type, value, name }) => {
        return (
          <Grid item key={type}>
            <li className={classes.liReset}>
              <Chip
                className={classes.chip}
                label={getFilterLabel(name, type, value)}
                onDelete={() => deleteStatus(type)}
              />
            </li>
          </Grid>
        )
      })}
      <Grid item>
        <IconButton
          onClick={() => {
            getReturnsByFilter(request)
          }}
        >
          <Autorenew />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default ChipsReturn
